/* ===========================================================
   Rif Care — INGREDIENTS
   Vanilla port of period-plastic-unpacked.lovable.app
   No dependencies.
   =========================================================== */
(function () {
  'use strict';

  var root = document.getElementById('rif-ing');
  if (!root) return;

  var $  = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Scroll reveal ---------- */
  var revealObserver = null;
  if ('IntersectionObserver' in window) {
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          revealObserver.unobserve(e.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    $$('.rif-rise').forEach(function (el) { revealObserver.observe(el); });
  } else {
    $$('.rif-rise').forEach(function (el) { el.classList.add('is-in'); });
  }

  function registerReveals(scope) {
    if (!revealObserver) return;
    $$('.rif-rise', scope).forEach(function (el) {
      if (!el.classList.contains('is-in')) revealObserver.observe(el);
    });
  }

  function smoothTo(el) {
    if (!el) return;
    el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }

  /* ---------- 2. Entry quiz ---------- */
  var state = { uses: null, mostly: null, found: [], escape: null };

  $$('[data-quiz="uses"] .rif-choice').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.uses = btn.dataset.value;
      $$('[data-quiz="uses"] .rif-choice').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b === btn));
      });
      var follow = $('[data-quiz="mostly"]');
      if (state.uses === 'both') {
        follow.classList.add('is-open');
        registerReveals(follow);
        window.setTimeout(function () { smoothTo(follow); }, 90);
      } else {
        follow.classList.remove('is-open');
        state.mostly = state.uses;
        openChecklist();
      }
    });
  });

  $$('[data-quiz="mostly"] .rif-choice').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.mostly = btn.dataset.value;
      $$('[data-quiz="mostly"] .rif-choice').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b === btn));
      });
      openChecklist();
    });
  });

  function openChecklist() {
    var list = $('[data-step="checklist"]');
    list.classList.add('is-open');
    registerReveals(list);
    window.setTimeout(function () { smoothTo(list); }, 90);
  }

  /* ---------- 3. Ingredient checklist ---------- */
  var continueBtn = $('[data-action="checklist-continue"]');

  $$('.rif-opt').forEach(function (opt) {
    opt.addEventListener('click', function () {
      var on = opt.getAttribute('aria-pressed') === 'true';
      opt.setAttribute('aria-pressed', String(!on));
      var id = opt.dataset.value;
      if (on) {
        state.found = state.found.filter(function (v) { return v !== id; });
      } else {
        state.found.push(id);
        state.escape = null;
        $$('.rif-escape').forEach(function (e) { e.setAttribute('aria-pressed', 'false'); });
      }
      syncContinue();
    });
  });

  $$('.rif-escape').forEach(function (esc) {
    esc.addEventListener('click', function () {
      var on = esc.getAttribute('aria-pressed') === 'true';
      $$('.rif-escape').forEach(function (e) { e.setAttribute('aria-pressed', 'false'); });
      esc.setAttribute('aria-pressed', String(!on));
      state.escape = on ? null : esc.dataset.value;
      if (!on) {
        state.found = [];
        $$('.rif-opt').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
      }
      syncContinue();
    });
  });

  function syncContinue() {
    if (!continueBtn) return;
    continueBtn.disabled = state.found.length === 0 && !state.escape;
  }
  syncContinue();

  if (continueBtn) {
    continueBtn.addEventListener('click', function () { unlock('plastic'); });
  }

  /* ---------- 4. Chapter progression ---------- */
  function unlock(name) {
    var ch = $('[data-chapter="' + name + '"]');
    if (!ch) return;
    ch.classList.add('is-open');
    registerReveals(ch);
    window.setTimeout(function () { smoothTo(ch); }, 90);
    if (name === 'plastic') { recalc(); }
  }

  $$('[data-unlock]').forEach(function (btn) {
    btn.addEventListener('click', function () { unlock(btn.dataset.unlock); });
  });

  /* ---------- 5. Research panels ---------- */
  $$('[data-research-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var open = !panel.hidden;
      panel.hidden = open;
      btn.setAttribute('aria-expanded', String(!open));
      btn.textContent = open ? 'See the research we used' : 'Hide research';
    });
  });

  /* ---------- 6. Accordions ---------- */
  $$('.rif-acc-head').forEach(function (head) {
    head.addEventListener('click', function () {
      var body = document.getElementById(head.getAttribute('aria-controls'));
      if (!body) return;
      var open = !body.hidden;
      body.hidden = open;
      head.setAttribute('aria-expanded', String(!open));
    });
  });

  /* ---------- 7. Calculator ---------- */
  var GRAMS_PER_PAD    = 2;
  var GRAMS_PER_BOTTLE = 9.25;
  var GRAMS_PER_POUND  = 453.592;
  var MAX_DRAWN        = 1100;

  var sliders = {
    perDay: $('#rif-per-day'),
    days:   $('#rif-days'),
    cycles: $('#rif-cycles'),
    years:  $('#rif-years')
  };

  var out = {
    perDay:  $('#rif-per-day-out'),
    days:    $('#rif-days-out'),
    cycles:  $('#rif-cycles-out'),
    years:   $('#rif-years-out'),
    eq:      $('[data-out="equation"]'),
    bottles: $('[data-out="bottles"]'),
    pounds:  $('[data-out="pounds"]'),
    ratio:   $('[data-out="ratio"]')
  };

  var nf = new Intl.NumberFormat('en-US');
  var totals = { pads: 0, grams: 0, bottles: 0, pounds: 0 };

  Object.keys(sliders).forEach(function (k) {
    if (sliders[k]) sliders[k].addEventListener('input', recalc);
  });

  function recalc() {
    if (!sliders.perDay) return;

    var perDay = +sliders.perDay.value;
    var days   = +sliders.days.value;
    var cycles = +sliders.cycles.value;
    var years  = +sliders.years.value;

    if (out.perDay) out.perDay.textContent = perDay;
    if (out.days)   out.days.textContent   = days;
    if (out.cycles) out.cycles.textContent = cycles;
    if (out.years)  out.years.textContent  = years;

    totals.pads    = perDay * days * cycles * years;
    totals.grams   = totals.pads * GRAMS_PER_PAD;
    totals.bottles = Math.round(totals.grams / GRAMS_PER_BOTTLE);
    totals.pounds  = Math.round(totals.grams / GRAMS_PER_POUND);

    var unit = state.mostly === 'tampons' ? 'tampons' : 'pads';

    if (out.eq) {
      out.eq.textContent = nf.format(totals.pads) + ' ' + unit + ' × ' +
        GRAMS_PER_PAD + 'g = ' + nf.format(totals.grams) + ' grams of plastic.';
    }
    if (out.pounds) out.pounds.textContent = nf.format(totals.pounds);

    var drawn = Math.min(totals.bottles, MAX_DRAWN);
    if (out.ratio) {
      out.ratio.textContent = totals.bottles > MAX_DRAWN
        ? nf.format(drawn) + ' shown × ' + Math.round(totals.bottles / drawn) +
          ' = ' + nf.format(totals.bottles) + ' water bottles'
        : nf.format(totals.bottles) + ' water bottles';
    }

    drawBottles(drawn);
    if (bottlesSeen) countUp(totals.bottles);
  }

  /* ---------- 8. Bottle canvas ---------- */
  var canvas = $('#rif-bottle-canvas');
  var ctx    = canvas ? canvas.getContext('2d') : null;
  var COLS   = 44;
  var CELL_W = 14;
  var CELL_H = 26;
  var revealRatio = 0;
  var bottlesSeen = false;
  var targetCount = 0;
  var countRaf = null;

  function sizeCanvas(count) {
    if (!canvas) return { cols: 1, rows: 0 };
    var cols = Math.min(COLS, Math.max(12, Math.floor(canvas.parentElement.clientWidth / CELL_W)));
    var rows = Math.ceil(count / cols) || 1;
    var dpr  = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width  = cols * CELL_W * dpr;
    canvas.height = rows * CELL_H * dpr;
    canvas.style.height = (rows * CELL_H) + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    return { cols: cols, rows: rows };
  }

  function bottlePath(x, y) {
    ctx.beginPath();
    ctx.moveTo(x + 4.5, y + 3);
    ctx.lineTo(x + 6.5, y + 3);
    ctx.lineTo(x + 6.5, y + 6);
    ctx.quadraticCurveTo(x + 9, y + 8, x + 9, y + 12);
    ctx.lineTo(x + 9, y + 20);
    ctx.quadraticCurveTo(x + 9, y + 22, x + 7, y + 22);
    ctx.lineTo(x + 4, y + 22);
    ctx.quadraticCurveTo(x + 2, y + 22, x + 2, y + 20);
    ctx.lineTo(x + 2, y + 12);
    ctx.quadraticCurveTo(x + 2, y + 8, x + 4.5, y + 6);
    ctx.closePath();
  }

  function drawBottles(count) {
    if (!ctx) return;
    var grid = sizeCanvas(count);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    var filled = Math.floor(count * revealRatio);
    for (var i = 0; i < count; i++) {
      var cx = (i % grid.cols) * CELL_W;
      var cy = Math.floor(i / grid.cols) * CELL_H;
      bottlePath(cx, cy);
      if (i < filled) {
        ctx.fillStyle = 'rgba(155, 177, 224, 0.9)';
        ctx.fill();
      } else {
        ctx.strokeStyle = 'rgba(58, 50, 43, 0.18)';
        ctx.lineWidth = 1;
        ctx.stroke();
      }
    }
  }

  function countUp(target) {
    var countEl = out.bottles;
    if (!countEl) return;
    targetCount = target;
    if (reduceMotion) {
      countEl.textContent = nf.format(target);
      revealRatio = 1;
      drawBottles(Math.min(target, MAX_DRAWN));
      return;
    }
    var start = performance.now();
    var from  = parseInt(String(countEl.textContent).replace(/[^0-9]/g, ''), 10) || 0;
    var dur   = 1500;
    if (countRaf) cancelAnimationFrame(countRaf);
    (function step(now) {
      var t = Math.min((now - start) / dur, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      countEl.textContent = nf.format(Math.round(from + (target - from) * eased));
      revealRatio = eased;
      drawBottles(Math.min(targetCount, MAX_DRAWN));
      if (t < 1) countRaf = requestAnimationFrame(step);
    })(start);
  }

  if ('IntersectionObserver' in window && canvas) {
    new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          bottlesSeen = true;
          countUp(totals.bottles);
          obs.disconnect();
        }
      });
    }, { threshold: 0.25 }).observe(canvas.parentElement);
  }

  window.addEventListener('resize', function () {
    drawBottles(Math.min(totals.bottles, MAX_DRAWN));
  });

  /* ---------- 9. Start over ---------- */
  var restart = $('[data-action="restart"]');
  if (restart) {
    restart.addEventListener('click', function () {
      state = { uses: null, mostly: null, found: [], escape: null };
      $$('[aria-pressed]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      $$('.rif-locked').forEach(function (el) { el.classList.remove('is-open'); });
      $$('.rif-research').forEach(function (p) { p.hidden = true; });
      $$('[data-research-toggle]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        b.textContent = 'See the research we used';
      });
      revealRatio = 0;
      bottlesSeen = false;
      syncContinue();
      smoothTo(root);
    });
  }

  recalc();
})();
